
































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import Button from '@/components/Button.vue';
import { EModalSizes } from '@/enums/ModalSizes';
import { EButtonTypes } from '@/enums/ButtonType.ts';
import Input from '@/components/Input.vue';
import Checkbox from '@/components/Checkbox.vue';
import RadioCheckbox from '@/components/RadioCheckbox.vue';
import { IForwardRecipientInfo } from '@signing-page/signing/types/forward-recipient-info';
import { IRecipient } from '@signing-page/documents/types/recipient';
import { ERecipientRole } from '@/dealroom/recipients/types/enums/recipient-role';

@Component({
  components: {
    Button,
    Input,
    Checkbox,
    RadioCheckbox,
  },
  data: () => ({ EModalSizes, EButtonTypes }),
})
export default class ForwardModal extends Vue {
  @Prop() forwarded: boolean;
  @Prop() hasSmsToSign: boolean;
  @Prop() isLoading: boolean;
  @Prop() recipient!: IRecipient;
  @Prop() isSigned: boolean;
  @Prop() isSigningForward: boolean;

  transferYes = false;
  transferNo = false;
  firstName = '';
  lastName = '';
  email = '';
  mobile = '';

  get filledOutRequired(): boolean {
    if (this.allowRoleTransfer && !this.roleTransferSelected) {
      return false;
    }
    const standardRequiredFieldsFilled: boolean =
      !!this.firstName && !!this.lastName && !!this.email;

    return this.hasSmsToSign
      ? standardRequiredFieldsFilled && !!this.mobile
      : standardRequiredFieldsFilled;
  }

  get allowRoleTransfer(): boolean {
    return this.recipient.role === ERecipientRole.Signer && !this.isSigned && this.isSigningForward;
  }

  get roleTransferSelected(): boolean {
    return this.transferYes || this.transferNo;
  }

  handleCheckboxClick(isTransferring: boolean) {
    if (isTransferring) {
      this.transferYes = true;
      this.transferNo = false;
    } else {
      this.transferYes = false;
      this.transferNo = true;
    }
  }

  sendForward() {
    const recipientInfo: IForwardRecipientInfo = {
      firstName: this.firstName,
      lastName: this.lastName,
      email: this.email,
      mobile: this.mobile,
      transferSignature: this.transferYes,
    };
    this.$emit('forward', recipientInfo);
  }

  handleClose() {
    this.$emit('close');
  }
}
